import React from 'react';
import { connect } from 'react-redux';
import AlertMessage from './AlertMessage';
import { useLocation, Navigate } from 'react-router-dom';

/**
 * A wrapper component to create the container that will hold all of the alert messages
 * @param {array} props.alerts - The array of all alert messages to be displayed
 */

export function UnconnectedAlertMessageContainer(props) {
  let location = useLocation();
  const { alerts, messages } = props;
  function displayAlerts() {
    return alerts.map((alert) => {
      const message = messages[alert];
      if (message.redirect) {
        return (
          <Navigate
            to="/logout"
            state={{ status: message.status }}
            replace
          />
        );
      } else {
        return (
          <AlertMessage
            key={alert}
            messageId={alert}
            data-test="alert-message"
          />
        );
      }
    });
  }

  return (
    <div
      className="ui-alert-message__messages-container"
      data-test="alert-message-container">
      {location.pathname !== '/logout' ? displayAlerts() : ''}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    alerts: Object.keys(state.ui.uiMessages),
    messages: state.ui.uiMessages,
  };
};

export default connect(mapStateToProps)(UnconnectedAlertMessageContainer);
